/**
 * Notification module
 *
 * @module notification
 */
import NotificationModel from './models/notification';
import {notifications} from './singletons/notification';

// MODULE INITIALIZATION
// =====================
// All collection and model instances and event listeners
// are created when the module is initialized.

/**
 * Init handler
 * @event {@link module:imageEditor#imageEditor:init|imageEditor:init}
 * @param {object} options Normally undefined, but a manual init trigger may override properties of Netx.custom.imageEditor here.
 */
dispatcher.once('notification:init', function () {
	// PUBLIC MODELS & COLLECTIONS
	// ===========================
	// Object initializations, etc, go here.

	// BEGIN DISPATCHER EVENT LISTENERS
	// ================================
	// All other module event listeners are added here, inside the init handler.

	/**
	 * @event module:notification#notification
	 * @param {object} options Notification options
	 */
	dispatcher.on('notification', function (attributes, options) {
		const model = new NotificationModel(attributes, {
			storeOptions: options,
		});
		// Give the notification model a chance to deal with initialization completely
		_.defer(function () {
			notifications.add(model);
		});
	});
	// END DISPATCHER EVENT LISTENERS

	// LAST STEPS:
	// non-core extensions may listen on this event to hook into the init process:
	dispatcher.trigger('notification:extend');
	// Tell the module loader we're initialized.
	dispatcher.trigger('notification:initialized');
});

export default {
	initialize(opts) {
		return new Promise((resolve, reject) => {
			dispatcher.once('notification:initialized', resolve);
			dispatcher.trigger('notification:init');
		});
	},
};
